/**
 *
 * *****************************************
 * *** Matthew Rawson @ 08/08/2017 18:07 ***
 * *****************************************
 *
 * Admin deals constants:
 * not sure if it's better to store this on sub-folder level
 *
 * These are reusable constants to maintain consistency of variable values and names
 * throughout the package.
 *
 * A naming convention probably needs to be worked out between all constant files.
 *
 */
const legacyBulletPointChar = "\u2022"
const bulletPointChar = "-"
const horizontalRuleChar = "---"
const heading1Char = "#"
const heading2Char = "##"
const heading3Char = "###"
const italicChar = "*"
const boldChar = "**"
const escapeChar = "\\"
const newlineChar = "\n"

export default Object.freeze({
  LEGACY_BULLET_POINT_CHAR: legacyBulletPointChar,
  LEGACY_BULLET_POINT_CHAR_FOR_REGEX: `${legacyBulletPointChar}`,
  BULLET_POINT_CHAR: bulletPointChar,
  BULLET_POINT_CHAR_FOR_REGEX: `${bulletPointChar}`,
  HORIZONTAL_RULE_CHAR: horizontalRuleChar,
  HORIZONTAL_RULE_CHAR_FOR_REGEX: horizontalRuleChar,
  HEADING_1_CHAR: heading1Char,
  HEADING_1_CHAR_FOR_REGEX: heading1Char,
  HEADING_2_CHAR: heading2Char,
  HEADING_2_CHAR_FOR_REGEX: heading2Char,
  HEADING_3_CHAR: heading3Char,
  HEADING_3_CHAR_FOR_REGEX: heading3Char,
  ITALIC_CHAR: italicChar,
  ITALIC_CHAR_FOR_REGEX: `${escapeChar}${italicChar}`,
  BOLD_CHAR: boldChar,
  BOLD_CHAR_FOR_REGEX: `${escapeChar}*${escapeChar}*`,
  ESCAPE_CHAR: escapeChar,
  ESCAPE_CHAR_FOR_REGEX: `${escapeChar}${escapeChar}`,
  NEW_LINE_SEPARATOR: `${newlineChar}`,
  NEW_PARAGRAPH_SEPARATOR: `${newlineChar}${newlineChar}`
})
